import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const sanitizeForId = (label: string) => {
  return label
    .toLowerCase()
    .replace(/[^\w\s]|(\s+)/g, (_match: string, group1: string) =>
      group1 ? '-' : ''
    );
};

// Re-export from utils folder
export { getSimpleCardStatusDescription } from '../utils/cardStatusHelpers';
export { sortAttributesByColorAndName } from '../utils/sortAttributes';
export {
  clearAllStorageAndCaches,
  clearAllStorageAndCachesSilent,
} from './utils/storage-utils';
